import { UploadOutlined } from '@ant-design/icons';
import { Checkbox, Col, DatePicker, Form, Input, Modal, Radio, Row, Select, Spin, Upload, message } from 'antd';
import { UploadChangeParam } from 'antd/es/upload';
import { UploadFile } from 'antd/es/upload/interface';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { validate } from 'rut.js';
import { useFormContext } from '../../Context/DeclarationContext';
import { phoneNumberCountryType } from '../../Interfaces/Declaration.Interface';
import { getLicenseClasses, getLicenseTypes, getUrlFileBase64, uploadFiles } from '../../Services/declarations';
import RutTools from '../../helpers/format-rut';
import { FILE_UPLOAD_GENERAL_ERROR, FILE_UPLOAD_LARGE_ERROR, formatRUT, getBase64 } from '../../utils/generals';
import FormInputPhone2 from '../Inputs/Form_Input_Phone/form_input_phone2';
import './driver_form.scss';

type Props = {
  selectedForeignLicense: boolean;
  setSelectedForeignLicense: React.Dispatch<React.SetStateAction<boolean>>;
};

type PreviewFile = {
  previewOpen: boolean;
  title: string;
  url: string;
};

export const DriverFormComponent = (props: Props) => {
  const [element_form] = Form.useForm();
  const { state, dispatch } = useFormContext();
  const [previewImage, setPreviewImage] = useState<PreviewFile>({
    previewOpen: false,
    title: '',
    url: '',
  });
  const [licenseTypes, setLicenseTypes] = useState<any[]>([]);
  const [licenseClasses, setLicenseClasses] = useState<any[]>([]);
  const [loadingFileRut, setLoadingFileRut] = useState(false);
  const [loadingfileListLic, setLoadingfileListLic] = useState(false);
  const [optionIdentifierType, setOptionIdentifierType] = useState<string>('');
  const [optionIsConsideredGuilty, setOptionIsConsideredGuilty] = useState(true);
  const [optionHasValidLicense, setOptionHasValidLicense] = useState(true);

  const [fileListLic, setFileListLic] = useState<any[]>(
    state.state_document?.find((doc) => doc.documentType === 'LIC') && state.state_document?.find((doc) => doc.documentType === 'LIC')?.filename
      ? [
          {
            uid: '-2',
            name: state.state_document?.find((doc) => doc.documentType === 'LIC')?.filename,
            status: 'done',
            url: state.state_document?.find((doc) => doc.documentType === 'LIC')?.url,
          },
        ]
      : []
  );
  const [fileListRut, setFileListRut] = useState<any[]>(
    state.state_document?.find((doc) => doc.documentType === 'DOCID') && state.state_document?.find((doc) => doc.documentType === 'DOCID')?.filename
      ? [
          {
            uid: '-2',
            name: state.state_document?.find((doc) => doc.documentType === 'DOCID')?.filename,
            status: 'done',
            url: state.state_document?.find((doc) => doc.documentType === 'DOCID')?.url,
          },
        ]
      : []
  );

  useEffect(() => {
    dispatch({
      type: 'UPDATE_CURRENT_FORM_ELEMENT',
      payload: element_form,
    });
  }, [state.step]);

  useEffect(() => {
    dispatch({
      type: 'SET_HEADER_TITLE',
      payload: 'Declaración de siniestros',
    });
  }, []);

  useEffect(() => {
    getLicenseTypes()
      .then((response) => {
        setLicenseTypes(response.data.licenseTypes);
      })
      .catch((error) => {
        console.log(error);
      });

    getLicenseClasses()
      .then((response) => {
        setLicenseClasses(response.data.licenseClasses);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (state.driver) {
      element_form.setFieldsValue({
        identifierType: state.driver?.identifierType,
        identityNumber: state.driver?.identifierType.includes('rut')
          ? formatRUT(state.driver?.identityNumber, { dots: true })
          : state.driver?.identityNumber,
        fullName: state.driver?.fullName,
        phoneNumber: state.driver?.phoneNumber ?? { phone_code: '+56', stringValue: '' },
        // emails: (state.driver?.emails?.length ?? [].length) > 0 ? state.driver?.emails?.map((email: any) => ({ email: email })) : [{ email: '' }],
        licenseTypeId: state.driver?.licenseTypeId ? state.driver?.licenseTypeId : '',
        licenseClassId: state.driver?.licenseClassId ? state.driver?.licenseClassId : '',
        isConsideredGuilty: state.driver?.isConsideredGuilty,
        hasValidLicense: state.driver?.hasValidLicense,
        licenseValidityStartDate: state.driver?.licenseValidityStartDate ? state.driver?.licenseValidityStartDate : undefined,
        licenseValidityEndDate: state.driver?.licenseValidityEndDate ? state.driver?.licenseValidityEndDate : undefined,
        emails: state.driver?.emails?.length > 0 ? [state.driver?.emails[0]] : [{ email: '' }],
        // identifierType: state.declarant?.identifierType,
      });
      // element_form.validateFields(['identityNumber']);
    }
    // }, [state, state.driver, initialIdentifierFlag, element_form]);
  }, []);

  const onFinishFailed = () => {
    dispatch({
      type: 'UPDATE_CURRENT_FORM',
      payload: 1,
    });
  };

  const onFinish = (declarant: any) => {
    if ((state.currentForm ?? 0) < 2) {
      dispatch({
        type: 'UPDATE_CURRENT_FORM',
        payload: 2,
      });
    }
  };

  const onChangeValues = (changedValues: any, allValues: any) => {
    console.log('onChangeValues Step2: ', allValues);
    if (changedValues.licenseTypeId) {
      element_form.setFieldsValue({ licenseClassId: undefined });
    }

    if (allValues.licenseValidityStartDate && allValues.licenseValidityEndDate) {
      const start = allValues.licenseValidityStartDate.format('YYYY-MM-DD');
      const end = allValues.licenseValidityEndDate.format('YYYY-MM-DD');
      if (moment(start).isBefore(end)) {
        element_form.setFields([
          {
            name: 'licenseValidityStartDate',
            errors: [],
          },
          {
            name: 'licenseValidityEndDate',
            errors: [],
          },
        ]);
      }
    }

    const phoneNumber = allValues.phoneNumber as phoneNumberCountryType;
    if (!phoneNumber.phone_code) {
      allValues.phoneNumber = { ...allValues.phoneNumber, phone_code: '+56' };
    }

    dispatch({
      type: 'UPDATE_DRIVER',
      payload: allValues,
    });
  };

  const onChangeIdentifierType = (e: any) => {
    const valueType = e.target.value;
    setOptionIdentifierType(valueType);
    element_form.setFieldsValue({ identityNumber: undefined });
    dispatch({
      type: 'UPDATE_DRIVER',
      payload: {
        ...state.driver,
        identityNumber: '',
        identifierType: valueType,
      },
    });
  };

  const onChangeIsConsideredGuilty = (e: any) => {
    setOptionIsConsideredGuilty(e.target.value);
  };

  const onChangeHasValidLicense = (e: any) => {
    setOptionHasValidLicense(e.target.value);
  };

  const beforeUploadValidations = (info: UploadChangeParam<UploadFile<any>>): boolean => {
    const isJpgOrPng =
      info.file.type === 'image/jpg' || info.file.type === 'image/png' || info.file.type === 'image/jpeg' || info.file.type === 'application/pdf';
    if (!isJpgOrPng) {
      message.error('Solo puede subir archivos JPG, PNG, JPEG o PDF');
    }
    const size = info.file.size ?? 0;
    const isLt2M = size / 1024 / 1024 <= 10;
    if (!isLt2M) {
      message.error(FILE_UPLOAD_LARGE_ERROR);
    }
    return isJpgOrPng && isLt2M;
  };

  const onUploadRut = async (info: UploadChangeParam<UploadFile<any>>) => {
    console.log('onUploadRut file info: ', info);

    if (info.file.status === 'removed') {
      let documents = state?.state_document || [];
      const indexToDrop = documents.findIndex(({ documentType }) => documentType === 'DOCID');
      if (indexToDrop !== -1) {
        documents[indexToDrop].filename = null;
        documents[indexToDrop].url = '';
        documents[indexToDrop].isActive = true;

        dispatch({
          type: 'UPDATE_STATE_DOCUMENT',
          payload: [...documents],
        });
        message.success('Documento eliminado correctamente');
        setFileListRut([]);
      }
    }

    if (info.file !== undefined && info.file.status !== 'removed') {
      const beforeValidations = beforeUploadValidations(info);
      if (beforeValidations) {
        info.file.name = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state?.declarant?.customerIdentityNumber || ('' as string))}`;
        try {
          setLoadingFileRut(true);
          const response = await uploadFiles(
            info.file.originFileObj,
            'DOCID',
            `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber || ('' as string))}`
          );
          let document = state?.state_document || [];
          info.file.status = 'done';
          const index = document.findIndex((doc) => doc.documentType === 'DOCID');
          if (index !== -1) {
            document[index].filename = response.data[0].filename;
            document[index].url = response.data[0].url;
            document[index].isActive = true;

            setFileListRut([
              {
                name: response.data[0].filename,
                url: response.data[0].url,
                isActive: true,
                status: 'done',
              },
            ]);
          }

          dispatch({
            type: 'UPDATE_STATE_DOCUMENT',
            payload: [...document],
          });
          message.success('Documento Rut subido correctamente');
        } catch (error) {
          const g = error as any;
          if (g?.status === 413) {
            message.error(FILE_UPLOAD_LARGE_ERROR);
          } else {
            message.error(FILE_UPLOAD_GENERAL_ERROR);
          }
        } finally {
          setLoadingFileRut(false);
        }
      } else {
        setFileListRut([]);
      }
    }
  };

  const onUploadLicencia = async (info: UploadChangeParam<UploadFile<any>>) => {
    console.log('onUploadLicencia file info: ', info);

    if (info.file.status === 'removed') {
      let documents = state?.state_document || [];
      const indexToDrop = documents.findIndex(({ documentType }) => documentType === 'LIC');
      if (indexToDrop !== -1) {
        documents[indexToDrop].filename = null;
        documents[indexToDrop].url = '';
        dispatch({
          type: 'UPDATE_STATE_DOCUMENT',
          payload: [...documents],
        });
        message.success('Documento eliminado correctamente');
        setFileListLic([]);
      }
    }

    if (info.file !== undefined && info.file.status !== 'removed') {
      const beforeValidations = beforeUploadValidations(info);
      if (beforeValidations) {
        info.file.name = `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state?.declarant?.customerIdentityNumber || ('' as string))}`;

        try {
          setLoadingfileListLic(true);
          const response = await uploadFiles(
            info.file.originFileObj,
            'LIC',
            `${state.vehiclePatente?.deviceId}_${RutTools.formatWithoutDots(state.declarant?.customerIdentityNumber || ('' as string))}`
          );
          let document = state?.state_document || [];
          info.file.status = 'done';
          const index = document.findIndex((doc) => doc.documentType === 'LIC');
          if (index !== -1) {
            document[index].filename = response.data[0].filename;
            document[index].url = response.data[0].url;
            document[index].isActive = true;

            setFileListLic([
              {
                name: response.data[0].filename,
                url: response.data[0].url,
                isActive: true,
                status: 'done',
              },
            ]);
          }

          dispatch({
            type: 'UPDATE_STATE_DOCUMENT',
            payload: [...document],
          });
          message.success('Documento licencia subido correctamente');
        } catch (error) {
          const g = error as any;
          if (g?.status === 413) {
            message.error(FILE_UPLOAD_LARGE_ERROR);
          } else {
            message.error(FILE_UPLOAD_GENERAL_ERROR);
          }
        } finally {
          setLoadingfileListLic(false);
        }
      } else {
        setFileListLic([]);
      }
    }
  };

  const [checkReusingData, setCheckReusingData] = useState(false);

  const handlePreviewFile = async (file: UploadFile) => {
    if (!file.url && !file.preview && file.originFileObj) {
      file.preview = await getBase64(file.originFileObj);
    }

    if (file.name.toLocaleLowerCase().includes('.pdf')) {
      const response = await getUrlFileBase64(file.name);
      const byteCharacters = atob(response.data.buffer);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    } else {
      setPreviewImage({
        previewOpen: true,
        url: file.url || (file.preview as string),
        title: file.name,
      });
    }
  };

  return (
    <div
      style={{
        marginTop: '24px',
      }}
      className="driver_form"
    >
      <div className="title">2. Datos del conductor</div>
      <div className="sub_title">Los campos marcados con el asterisco (*) son obligatorios.</div>

      <Form onFinish={onFinish} onFinishFailed={onFinishFailed} colon={false} form={element_form} onValuesChange={onChangeValues}>
        <Row
          gutter={[24, 24]}
          style={{
            marginTop: '12px',
            marginBottom: '14px',
          }}
        >
          <Col sm={24}>
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  setCheckReusingData(true);
                  element_form.setFieldsValue({
                    identityNumber: state.declarant?.declarantIdentityNumber,
                    fullName: state.declarant?.declarantFullName,
                    phoneNumber: state.declarant?.phoneNumber,
                    emails: state.declarant?.emails?.length ?? 0 > 1 ? [{ email: state.declarant?.emails[0] }] : [],
                    identifierType: state.declarant?.identifierType,
                  });

                  dispatch({
                    type: 'UPDATE_DRIVER_PERSONAL_INFO',
                    payload: {
                      identifierType: state.declarant?.identifierType,
                      identityNumber: state.declarant?.declarantIdentityNumber,
                      fullName: state.declarant?.declarantFullName,
                      phoneNumber: state.declarant?.phoneNumber,
                      emails: state.declarant?.emails?.length ?? 0 > 1 ? [{ email: state.declarant?.emails[0] }] : [],
                    },
                  });
                  setOptionIdentifierType(state.declarant?.identifierType || 'rut');
                } else {
                  setCheckReusingData(false);
                  element_form.setFieldsValue({
                    identityNumber: '',
                    fullName: '',
                    phoneNumber: { phone_code: '+56', stringValue: '' },
                    emails: [{ email: '' }],
                  });
                }
              }}
            >
              Utilizar los datos del declarante
            </Checkbox>
          </Col>
        </Row>

        <Row gutter={[24, 24]} justify="center">
          <Col sm={8} xs={24}>
            <Form.Item label="Seleccionar documento identificador" name="identifierType" initialValue="rut">
              <Radio.Group onChange={onChangeIdentifierType} value={optionIdentifierType} disabled={checkReusingData}>
                <Radio value={'rut'}>Rut</Radio>
                <Radio value={'pasaporte'}>Pasaporte</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item
              required={true}
              label="RUT o Pasaporte del conductor"
              name="identityNumber"
              dependencies={['identifierType']}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const identifierType = getFieldValue('identifierType');

                    if (identifierType === 'rut') {
                      if (!value) {
                        return Promise.reject(new Error('Ingrese el RUT.'));
                      } else if (!validate(value)) {
                        return Promise.reject(new Error('El RUT ingresado es inválido.'));
                      }
                    }

                    if (identifierType === 'pasaporte') {
                      if (!value) {
                        return Promise.reject(new Error('Ingrese el pasaporte.'));
                      }
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
              normalize={element_form.getFieldValue('identifierType') === 'rut' ? (value) => formatRUT(value, { dots: true }) : undefined}
            >
              <Input placeholder={element_form.getFieldValue('identifierType') === 'rut' ? 'Ejemplo: 11111111-1' : ''} maxLength={15} />
            </Form.Item>
          </Col>
          <Col sm={8} xs={24}>
            <Form.Item label="Adjuntar RUT">
              <Spin spinning={loadingFileRut} size="small">
                <Upload
                  name="avatar"
                  listType="picture"
                  customRequest={() => {}}
                  defaultFileList={fileListRut.length ? [...fileListRut] : []}
                  fileList={fileListRut.length ? [...fileListRut] : []}
                  onPreview={handlePreviewFile}
                  maxCount={1}
                  onChange={onUploadRut}
                >
                  <div className="upload_file">
                    <UploadOutlined /> Subir archivo
                  </div>
                  <small className="text_small">Archivos JPG, PNG, JPEG, PDF - Tamaño máximo 10MB.</small>
                </Upload>
              </Spin>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col sm={8} xs={24}>
            <Form.Item
              label="Nombre completo del conductor"
              name="fullName"
              rules={[
                {
                  required: true,
                  message: 'Debe ingresar el nombre completo del conductor',
                },
                {
                  pattern: /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s0-9.&-_]+$/,
                  message: 'Los nombres no pueden incluir caracteres especiales',
                },
                {
                  max: 200,
                  message: 'Debe tener máximo 200 caracteres',
                },
              ]}
            >
              <Input disabled={checkReusingData} />
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <FormInputPhone2
              prevalue={state.driver?.phoneNumber ?? { phone_code: '+56', stringValue: '' }}
              label="Teléfono del conductor"
              name="phoneNumber"
              disabled={checkReusingData}
            />
          </Col>
          <Col sm={8} xs={24}>
            <Form.List name="emails">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Form.Item
                      key={key}
                      {...restField}
                      name={[name, 'email']}
                      label={`Correo electrónico  ${name + 1} del conductor`}
                      rules={[
                        {
                          type: 'email',
                          message: 'El correo electrónico no es válido',
                        },
                        {
                          required: true,
                          message: 'Debe ingresar el correo electrónico',
                        },
                      ]}
                    >
                      <Input disabled={checkReusingData} />
                    </Form.Item>
                  ))}
                </>
              )}
            </Form.List>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col sm={8} xs={24}>
            <Form.Item
              label="Tipo de licencia de conducir"
              name="licenseTypeId"
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
              ]}
            >
              <Select
                style={{
                  width: '100%',
                  height: '48px',
                }}
                placeholder="Seleccionar"
                onChange={(idLicense) => {
                  const foreignLicense = licenseTypes.find(({ name }) => {
                    return name?.toUpperCase() === 'EXTRANJERA';
                  });
                  if (foreignLicense?.id === idLicense) {
                    props.setSelectedForeignLicense(true);
                  } else {
                    props.setSelectedForeignLicense(false);
                  }
                }}
              >
                {licenseTypes?.map((licenseType) => {
                  return (
                    <Select.Option key={licenseType.id} value={licenseType.id}>
                      {licenseType.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item
              label="Clase de licencia de conducir"
              name="licenseClassId"
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
              ]}
            >
              <Select
                style={{
                  width: '100%',
                  height: '48px',
                }}
                placeholder="Seleccionar"
              >
                {props.selectedForeignLicense
                  ? licenseClasses
                      ?.filter(({ name }) => {
                        return name?.toUpperCase() === 'OTRA';
                      })
                      .map((licenseClass) => {
                        return (
                          <Select.Option key={licenseClass.id} value={licenseClass.id}>
                            {licenseClass.name}
                          </Select.Option>
                        );
                      })
                  : licenseClasses?.map((licenseClass) => {
                      return (
                        <Select.Option key={licenseClass.id} value={licenseClass.id}>
                          {licenseClass.name}
                        </Select.Option>
                      );
                    })}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col sm={8} xs={24}>
            <Form.Item
              label="¿En este siniestro, se considera culpable?"
              name="isConsideredGuilty"
              initialValue={true}
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
              ]}
            >
              <Radio.Group onChange={onChangeIsConsideredGuilty} value={optionIsConsideredGuilty}>
                <Radio value={true}>Si</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item
              label="¿Licencia vigente?"
              name="hasValidLicense"
              initialValue={true}
              rules={[
                {
                  required: true,
                  message: 'Este campo es requerido',
                },
              ]}
            >
              <Radio.Group onChange={onChangeHasValidLicense} value={optionHasValidLicense}>
                <Radio value={true}>Si</Radio>
                <Radio value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item label="Adjuntar licencia de de conducir">
              <Spin spinning={loadingfileListLic} size="small">
                <Upload
                  name="avatar"
                  maxCount={1}
                  listType="picture"
                  defaultFileList={fileListLic?.length ? [...fileListLic] : []}
                  fileList={fileListLic?.length ? [...fileListLic] : []}
                  customRequest={() => {}}
                  onChange={onUploadLicencia}
                  onPreview={handlePreviewFile}
                >
                  <div className="upload_file">
                    <UploadOutlined /> Subir archivo
                  </div>
                  <small className="text_small">Archivos JPG, PNG, JPEG, PDF - Tamaño máximo 10MB.</small>
                </Upload>
              </Spin>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[24, 24]}>
          <Col sm={8} xs={24}>
            <Form.Item
              required
              label="Vigencia licencia desde"
              name="licenseValidityStartDate"
              rules={[
                {
                  validator: (_, value) => {
                    if (value) {
                      const licenseValidityEndDate = element_form.getFieldValue('licenseValidityEndDate');
                      const today = moment().format('YYYY-MM-DD');
                      const start = value.format('YYYY-MM-DD');
                      if (licenseValidityEndDate) {
                        const end = licenseValidityEndDate.format('YYYY-MM-DD');
                        if (moment(end).isSameOrBefore(start)) {
                          return Promise.reject(new Error('La vigencia de licencia desde, debe ser menor a la vigencia de licencia hasta'));
                        }
                      }
                      if (moment(start).isAfter(today)) {
                        return Promise.reject(new Error('La vigencia de licencia desde, debe ser menor o igual a la fecha actual'));
                      }
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Este campo es requerido'));
                  },
                },
              ]}
            >
              <DatePicker
                format={'DD-MM-YYYY'}
                style={{
                  width: '100%',
                  height: '48px',
                }}
              />
            </Form.Item>
          </Col>

          <Col sm={8} xs={24}>
            <Form.Item
              required
              label="Vigencia licencia hasta"
              name="licenseValidityEndDate"
              rules={[
                {
                  validator: (_, value) => {
                    if (value) {
                      const licenseValidityStartDate = element_form.getFieldValue('licenseValidityStartDate');
                      if (licenseValidityStartDate) {
                        const start = licenseValidityStartDate.format('YYYY-MM-DD');
                        const end = value.format('YYYY-MM-DD');
                        if (moment(end).isSameOrBefore(start)) {
                          return Promise.reject(new Error('La vigencia de licencia hasta, debe ser mayor a la vigencia de licencia desde'));
                        }
                      }
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Este campo es requerido'));
                  },
                },
              ]}
            >
              <DatePicker
                format={'DD-MM-YYYY'}
                style={{
                  width: '100%',
                  height: '48px',
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Modal
        open={previewImage.previewOpen}
        title={previewImage.title}
        footer={null}
        onCancel={() => setPreviewImage({ ...previewImage, previewOpen: false })}
        width={1000}
      >
        {['jpg', 'jpeg', 'png'].some((ext) => previewImage.title.toLowerCase().endsWith(`.${ext}`)) && (
          <img alt="preview" style={{ width: '100%' }} src={previewImage.url} />
        )}
      </Modal>
    </div>
  );
};
